function hasFeedbackText(value) {
  return typeof value === 'string' && value.trim().length > 0;
}

export function OverallFeedbackSection({ submission, accentColor = '#00A8A2', showScore = true }) {
  const overallFeedback = submission?.overallFeedback?.trim();
  const canShowScore = showScore && submission?.status === 'graded' && submission.totalScore != null;

  if (!hasFeedbackText(overallFeedback) && !canShowScore) {
    return null;
  }

  return (
    <div className="rounded-[10px] bg-white p-4 shadow-[0_4px_14px_rgba(15,23,42,0.06)]">
      {hasFeedbackText(overallFeedback) && (
        <>
          <p className="text-[13px] font-medium text-slate-700">بازخورد کلی معلم</p>
          <p className="mt-2 whitespace-pre-line text-[14px] font-medium leading-7 text-slate-900">{overallFeedback}</p>
        </>
      )}
      {canShowScore && (
        <p className={`${hasFeedbackText(overallFeedback) ? 'mt-3' : ''} text-[13px] font-bold`} style={{ color: accentColor }}>
          نمره دریافتی: {submission.totalScore}
        </p>
      )}
    </div>
  );
}

export function QuestionFeedbackBlock({ answer, accentColor = '#00A8A2', showScore = true }) {
  const feedback = answer?.feedback?.trim();
  const canShowScore = showScore && answer?.score != null;

  if (!hasFeedbackText(feedback) && !canShowScore) {
    return null;
  }

  return (
    <div className="rounded-[8px] bg-white px-3 py-2 text-slate-800">
      {hasFeedbackText(feedback) && (
        <>
          <p className="text-[12px] font-bold" style={{ color: accentColor }}>
            بازخورد معلم
          </p>
          <p className="mt-1 whitespace-pre-line text-[13px] leading-6">{feedback}</p>
        </>
      )}
      {canShowScore && (
        <p className={`${hasFeedbackText(feedback) ? 'mt-2' : ''} text-[12px] font-medium text-slate-700`}>
          نمره این سوال: {answer.score}
        </p>
      )}
    </div>
  );
}
